import { EventSource } from '@godspeedsystems/plugins-cron-as-eventsource';
export default EventSource;
                    